module.exports = __webpack_public_path__ + "media/assets/images/blog/giardiniere-small-c106dd5f39e515549b2000fbc673f90a.jpg";